import React, { useMemo, useState } from "react"
import {
  Card,
  Col,
  Row,
  Button,
  Carousel,
  Tabs,
  Avatar,
  Image,
  Input,
  Space,
  Spin,
  Typography,
} from "antd"

import SearchImg from "@/assets/images/search.png";
import CardDetail from "./cardDetail";
import useBaseRequest from "@/hooks/useBaseRequest";
import { getcategary, getcategaryList, getZntSearch } from "@/api/index";
import { isMobile } from "@/utils/public";
import "./index.less";

function Search(props) {
  const { onClick } = props
  const [activeKey, setActiveKey] = useState("0")
  const [inputValue, setInputValue] = useState("")
  const [inputCache, setInputCache] = useState("")
  const [searchRes, setSearchRes] = useState([])
  const { data: initCate, loading: loading2 } = useBaseRequest(getcategary, {
    // manual: true,
  })
  const isMob = isMobile()
  const {
    data: searchData,
    runAsync: runSearch,
    loading: searchLoading,
  } = useBaseRequest((key) => getZntSearch(key), {
    manual: true,
    onSuccess(res) {
      if (!inputValue) {
        setSearchRes(null)
      } else {
        setSearchRes(res)
        setInputCache(inputValue)
      }
    },
  })
  const {
    data: initCateList,
    loading,
    refresh,
  } = useBaseRequest(() => getcategaryList(activeKey), {
    // manual: true,
    refreshDeps: [activeKey],
  })
  const Items = useMemo(() => {
    const cateList = [{ name: "全部", id: "0" }, ...(initCate?.data ?? [])]
    console.log(cateList)
    const cate = cateList?.map((item) => {
      return {
        title: item.name,
        key: item.id + "",
        children:
          activeKey === item.id + ""
            ? initCateList?.data?.map((jtem) => {
              console.log(jtem, "多智能体搜索当中的")
              return {
                label: jtem.name,
                icon: jtem?.icon,
                summary: jtem?.summary,
                key: jtem.id + "",
                outerznt: jtem.outerznt,
                outerurl: jtem.outerurl
              }
            })
            : [],
      }
    })
    console.log(cate);
    return cate
  }, [initCateList, initCate, activeKey])
  return (
    <Spin spinning={loading2 || loading || searchLoading}>
      <div className='search'>
        {isMob ? (
          <div className='m-searchWrapperContent' >
            <div className='m-searchInput'>
              <Input
                placeholder='智能无限，搜索即现'
                value={inputValue}
                onChange={(e) => {
                  setInputValue(e.target.value)
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    runSearch(inputValue)
                  }
                }}
                suffix={
                  <img
                    style={{ cursor: "pointer", height: 35, width: 54 }}
                    onClick={() => {
                      runSearch(inputValue)
                    }}
                    src={SearchImg}
                  />
                }
              />

            </div>
            <div style={{ height: "calc(100% - 55px)", marginTop: 34, width: "100%" }}>
              <div className="m-content">
                {searchRes?.data ? (
                  <div style={{ width: "100%" }}>
                    <Typography.Paragraph
                      style={{
                        color: "#2c2c36",
                        fontSize: 18,
                        fontWeight: 500,
                        lineHeight: "32px",
                      }}
                    >{`与“${inputCache}”相关的智能体`}</Typography.Paragraph>
                    <CardDetail
                      style={{ width: "100%" }}
                      onClick={onClick}
                      mobile
                      data={searchRes?.data?.map((item) => ({
                        label: item.name,
                        icon: item?.icon,
                        summary: item?.summary,
                        key: item?.id + "",
                        outerznt: item.outerznt,
                        outerurl: item.outerurl
                      }))}
                    />
                  </div>
                ) : (
                  <>
                    <Tabs
                      style={{
                        height: "100%"
                      }}
                      type='card'
                      items={Items?.map((item, index) => {
                        console.log(item, "tabs的值")
                        return {
                          label: item?.title,
                          key: item.key,
                          children: <CardDetail mobile onClick={onClick} data={item?.children} />,
                        }
                      })}
                      tabBarGutter={15}
                      activeKey={activeKey}
                      onChange={(activeKey) => {
                        setActiveKey(activeKey + "")
                      }}
                    />
                  </>
                )}
              </div>
            </div>


          </div>
        ) : (
          <div className='searchWrapperContent sui-chatui-box-wrap'>
            <div style={{
              height: "100%"
            }}>
              <div className='searchInput'>
                <Input
                  placeholder='智能无限，搜索即现'
                  value={inputValue}
                  onChange={(e) => {
                    setInputValue(e.target.value)
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      runSearch(inputValue)
                    }
                  }}
                  suffix={
                    <img
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        runSearch(inputValue)
                      }}
                      src={SearchImg}
                    />
                  }
                />
              </div>
              <div className='searchContent'>
                {/* <div className='title'>欢迎来到AI未来门户</div> */}
                <div className='content'>
                  {searchRes?.data ? (
                    <>
                      <Typography.Paragraph
                        style={{
                          color: "#2c2c36",
                          fontSize: 18,
                          fontWeight: 500,
                          lineHeight: "32px",
                        }}
                      >{`与“${inputCache}”相关的智能体`}</Typography.Paragraph>
                      <CardDetail
                        style={{ width: "100%" }}
                        onClick={onClick}
                        data={searchRes?.data?.map((item) => ({
                          label: item.name,
                          icon: item?.icon,
                          summary: item?.summary,
                          key: item?.id + "",
                          outerznt: item.outerznt,
                          outerurl: item.outerurl
                        }))}
                      />
                    </>
                  ) : (
                    < >
                      <Space>{ }</Space>
                      <>
                        <Tabs
                          style={{
                            height: "100%"
                          }}
                          type='card'
                          items={Items?.map((item, index) => {
                            console.log(item, "tabs的值")
                            return {
                              label: item?.title,
                              key: item.key,
                              children: <CardDetail onClick={onClick} data={item?.children} />,
                            }
                          })}
                          tabBarGutter={30}
                          activeKey={activeKey}
                          onChange={(activeKey) => {
                            setActiveKey(activeKey + "")
                          }}
                        />
                      </>

                    </>
                  )}
                </div>
              </div>
            </div>

          </div>
        )}
      </div>
    </Spin>
  )
}

export default Search
